"use strict";function r(r){return r<100?"1px":"1.5px"}function o(r,o){return r||(o?"#F8F2E9FF":"#170B01FF")}exports.parseBasicOptions=function(t){var n=t.onDark,e=void 0!==n&&n,i=t.strokeColor,s=t.size,u=void 0===s?48:s;return{strokeColor:o(i,e),strokeWidth:r(u)}};
//# sourceMappingURL=parseBasicOptions.js.map
